module.exports = __webpack_public_path__ + "assets/L3ParallelDetailed.58920ca0880e640c15e67d1ab7af6dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/L3ParallelDetailed.png
// module id = 528
// module chunks = 0